import { render } from "./event_messages.vue?vue&type=template&id=48a158b1&scoped=true"
import script from "./event_messages.vue?vue&type=script&lang=js"
export * from "./event_messages.vue?vue&type=script&lang=js"

import "./event_messages.vue?vue&type=style&index=0&id=48a158b1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a158b1"]])

export default __exports__